export default __webpack_public_path__ + "static/media/dashboardDesign.a42eebf4.png";